import React from 'react';
import styled from 'react-emotion';

const MenuItemMobile = styled('div')(
  (props) => {
    const {
      color,
      backgroundColor,
      hoverColor,
      activeColor,
    } = props;

    return {
      color,
      backgroundColor,
      cursor: 'pointer',
      ':hover': {
        color: hoverColor,
      },
      '&[data-active]': {
        color: activeColor,
      },
    };
  }
);

export default MenuItemMobile;